import React from 'react';
import { Col, Container, Row, Button } from 'reactstrap';
import FormAddAdmission from './components/FormAddAdmision';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import history from '../../../history';
import moment from 'moment';

const AddAdmission = (props) => {
  const { dataPatient } = props.location.state;
  const patient_pending = props.location.state.patient_pending != null && props.location.state.patient_pending != undefined ? true : false;

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', margin: '0em 2em' }}>
            {patient_pending != true &&
              <div>
                <Tooltip
                  title="Regresar"
                  style={{ padding: '2px', backgroundColor: '#55e5bb' }}
                >
                  <IconButton
                    aria-label="upload picture"
                    component="span"
                    className='tooltip-top'
                    onClick={() => {
                      if (dataPatient != null && dataPatient != undefined && dataPatient != 'undefined') {
                        if (patient_pending == true) {
                          history.push({
                            pathname: process.env.PUBLIC_URL + '/management/patients-pending-invoice'
                          });
                        }
                        else if (dataPatient != null && dataPatient != undefined) {
                          history.push({
                            pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                            state: {
                              date: dataPatient.fecha,
                              estado_form: dataPatient.estado_form,
                              indexPageF: dataPatient.indexPage
                            }
                          });
                        }
                        else if (dataPatient.id_cita != null && dataPatient.id_cita != undefined && dataPatient.id_cita != 'undefined') {
                          history.push({
                            pathname: process.env.PUBLIC_URL + '/management/schedule'
                          });
                        }
                        else {
                          history.push({
                            pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                            state: { date: moment(new Date()).format("YYYY-MM-DD") }
                          });
                        }
                      }
                      else {
                        history.push({
                          pathname: process.env.PUBLIC_URL + '/assitencial/admissions',
                          state: { date: moment(new Date()).format("YYYY-MM-DD") }
                        });
                      }
                    }}
                  >
                    <ArrowBackIcon style={{ color: '#153365' }} />
                  </IconButton>
                </Tooltip>
              </div>
            }
            {typeof props.location.state.id_admision !== 'undefined' ?
              <div className="title-general-section-icon-arrow-back">
                <h3>Ver Admisión</h3>
              </div>
              :
              props.location.state.priority === 'Cumplida' || props.location.state.priority === 'Emergencia' ?
                <div className="title-general-section-icon-arrow-back">
                  <h3>Ver Admisión</h3>
                </div>
                :
                <div className="title-general-section-icon-arrow-back">
                  <h3>Agregar Admisión</h3>
                </div>
            }
          </div>
        </Col>
      </Row>
      <FormAddAdmission
        dataPatient={props.location.state}
        patient_pending={props.location.state.patient_pending != null && props.location.state.patient_pending != undefined ? true : false}
      />
    </Container>);
}
export default AddAdmission;